// Static test IDs
export const COLLAPSE_TREE_BUTTON_TESTID = "collapse-tree-button";
export const FILTERS_ADD_NEW_BUTTON_TESTID = "filters-add-new-button";
export const FILTERS_FOLDERS_PANEL_TESTID = "filter_folder_panel";
export const FILTERS_SEARCHABLE_INPUT_CLEAR_BUTTON_TESTID =
  "filters-searchable-input-container";
export const FILTERS_SEARCHABLE_INPUT_TESTID =
  "filters-searchable-input-container";
export const FILTERS_SEARCH_RESULT_TESTID = "filter-search-result";
export const FILTERS_SELECT_ALL_ITEMS_TESTID = "filters-select-all-items";
export const FILTERS_TAB_TESTID = "filters-tab";
export const FOLDERS_TAB_TESTID = "folders-tab";
export const FORM_SAVE_BUTTON_TESTID = "form-save-btn";
export const PROJECT_MENU_ISSUES_TESTID = "project-menu-issues";
export const PROJECT_MENU_TEST_LIBRARY_TESTID = "project-menu-test-library";
export const PROJECT_MENU_TESTSETS_TESTID = "project-menu-testsets";
export const PT_LIST_TREE_TESTID = "pt-list-tree";
export const PT_TREE_EMPTY_CHILDREN_TESTID = "pt-tree-empty-children";
export const PT_TREE_ITEM_TESTID = "pt-tree-item";
export const PT_TREE_ITEM_TOGGLE_BUTTON_TESTID = "pt-tree-item-toggle-button";
export const PT_TREE_NAME_BUTTON_TESTID = "pt-tree-name-button";
export const PT_TREE_TOGGLE_BUTTON_TESTID = "pt-tree-toggle-button";
export const SEARCHABLE_TREE_CLEAR_BUTTON_TESTID =
  "searchable-tree-clear-button";
export const SEARCHABLE_TREE_CONTAINER_TESTID = "searchable-tree-container";
export const SEARCHABLE_TREE_NO_ITEMS_FOUND_TESTID =
  "searchabletree-no-items-found";
export const SEARCHABLE_TREE_SEARCH_INPUT_TESTID = "search-input";
export const SEARCHABLE_TREE_SUGGESTIONS_TESTID =
  "searchable-tree-suggestions-container";
export const SEARCHABLE_TREE_TOGGLE_BUTTON_TESTID =
  "searchable-tree-toggle-button";
export const SEARCHABLE_TREE_VALUE_HOLDER_TESTID =
  "searchabletree-value-holder";
export const SEARCHABLE_TREE_WEB_COMPONENT_TESTID =
  "searchable-tree-web-component";

// Dynamic test ID generators
export const getPtTreeItemTestId = (level: number | string) =>
  `pt-tree-item-${level}`;
export const getPtTreeItemButtonTestId = (level: number | string) =>
  `pt-tree-item-${level}-button`;
export const getTabTestId = (label: string) => `${label.toLowerCase()}-tab`;
